import {Container, InfoWrap, ItemText, ItemTitle, List, ListItem} from "./styled";
import {ReadMore} from "../ReadMore/ReadMore";
import {YearsStats} from "./Stats/YearsStats/YearsStats";
import {IndustryStats} from "./Stats/IndustryStats/IndustryStats";
import {getProductAnchor} from "../../../utils";

export const Description = ({data}) => {
    const products = data?.products || [];

    return (
        <Container>
            <List>
                {products.map((product, index) => {
                    const productItem = product?.item;
                    const anchor = getProductAnchor(productItem?.title);
                    const descriptionLines = productItem?.description?.split('\n').filter(line => line.trim()) || [];
                    const readMoreLines = productItem?.read_more_description?.split('\n').filter(line => line.trim()) || [];
                    const statistics = productItem?.statistics || [];
                    const hasYearStats = statistics.some(stat => stat?.item?.title?.match(/^\d{4}$/));
                    const hasIndustryStats = statistics.some(stat => !stat?.item?.title?.match(/^\d{4}$/));

                    return (
                        <ListItem key={productItem?.id || index} id={anchor}>
                            <InfoWrap>
                                <ItemTitle>
                                    {index + 1}. {productItem?.title}
                                </ItemTitle>
                                {descriptionLines.map((line, lineIndex) => (
                                    <ItemText key={lineIndex}>{line}</ItemText>
                                ))}
                                {readMoreLines.length > 0 && (
                                    <ReadMore>
                                        {readMoreLines.map((line, lineIndex) => (
                                            <ItemText key={lineIndex}>{line}</ItemText>
                                        ))}
                                    </ReadMore>
                                )}
                            </InfoWrap>
                            {hasYearStats && <YearsStats statistics={statistics}/>}
                            {hasIndustryStats && <IndustryStats statistics={statistics}/>}
                        </ListItem>
                    );
                })}
            </List>
        </Container>
    )
}
